<template>
  <div
    :class="{ 'brightness-95': this.$store.state.displayEditGeneral }"
    class="box shadow-none col-span-6"
  >
    <div
      class="text-left lg:text-left p-5 border-t border-gray-200 dark:border-dark-5"
    >
      <div class="flex flex-row flex-nowrap">
        <div class="flex flex-col w-1/2 mr-12">
          <Field
            id="supplierGroupId"
            title="Supplier Group ID:"
            type="text"
            :modelValue="supplierGroup.supplierGroupId"
            :disabled="true"
          />
          <Field
            id="brandingId"
            title="Branding ID:"
            type="text"
            :modelValue="supplierGroup.brandingId"
            :disabled="true"
            :copySuffix="true"
            :isCopied="copy.brandingId"
            @copy="copyField('brandingId')"
          />
          <div class="mb-3">
            <label for="type" class="font-bold form-label">Type*:</label>
            <Dropdown
              id="type"
              :key="supplierGroup.sgType"
              :data="typeData"
              :selected="supplierGroup.sgType"
              :disabled="true"
            />
          </div>
          <Field
            id="name"
            title="Name:"
            type="text"
            :modelValue="supplierGroup.name"
            :disabled="true"
            :copySuffix="true"
            :isCopied="copy.name"
            @copy="copyField('name')"
          />
          <div>
            <p class="font-bold">Project Status:</p>
            <Dropdown
              :data="optionStatuses"
              :selected="
                supplierGroup.status?.projectStatus
                  ? supplierGroup.status.projectStatus
                  : 'CREATED'
              "
              class="mb-3"
              :disabled="true"
            />
            <div class="flex flex-row">
              <p class="font-bold mr-2">Is Delinquent payer:</p>
              <ToggleSlide
                class="w-min"
                :bool="
                  supplierGroup.status?.isDelinquentPayer
                    ? supplierGroup.status.isDelinquentPayer
                    : false
                "
                :renew-bool="true"
                :disabled="true"
              />
            </div>
          </div>
        </div>
        <div class="flex flex-col w-1/2">
          <Field
            id="portalLink"
            title="Portal Link:"
            type="text"
            :modelValue="
              supplierGroup.channelsConfig.docImage.configPortal.portalLink
            "
            :disabled="true"
            :copySuffix="true"
            :isCopied="copy.portalLink"
            @copy="copyField('portalLink')"
          />
          <Field
            id="idpUrl"
            title="IDP url"
            type="text"
            :modelValue="
              supplierGroup.channelsConfig.docImage.configPortal.idpUrl
            "
            :disabled="true"
            :copySuffix="true"
            :isCopied="copy.idpUrl"
            @copy="copyField('idpUrl')"
          />
          <Field
            id="tacEmail"
            title="Terms and Conditions Email:"
            type="text"
            :modelValue="
              supplierGroup.channelsConfig.docImage.configPortal
                .termsOfServiceEmail
            "
            :disabled="true"
            :copySuffix="true"
            :isCopied="copy.termsOfServiceEmail"
            @copy="copyField('termsOfServiceEmail')"
          />
          <div class="mb-3">
            <label for="languages" class="font-bold form-label"
              >Languages*:</label
            >
            <DropdownSelectAll
              id="languages"
              :data="languages"
              :key="supplierGroup.languages"
              :selected="supplierGroup.languages"
              :disabled="true"
              :noSelectAll="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Field from "../Field.vue";
import Dropdown from "../Dropdown.vue";
import DropdownSelectAll from "../DropdownSelectAll.vue";
import ToggleSlide from "@/components/ToggleSlide.vue";

export default {
  name: "ViewGeneral",
  components: {
    ToggleSlide,
    Field,
    Dropdown,
    DropdownSelectAll,
  },
  props: {
    typeData: Array,
    languages: Array,
  },
  watch: {
    "$store.state.activeSG": {
      handler(data) {
        this.supplierGroup = data;
      },
      deep: true,
    },
  },
  data() {
    return {
      supplierGroup: this.$store.state.activeSG,
      copy: {
        name: false,
        brandingId: false,
        portalLink: false,
        idpUrl: false,
        termsOfServiceEmail: false,
      },
    };
  },
  computed: {
    optionStatuses() {
      let statuses = this.$store.state.statusesSG.map((status) => {
        return { name: status.status };
      });

      if (statuses[statuses.length - 1].name === "NOT_PAID") statuses.pop();
      return statuses;
    },
  },
  methods: {
    copyField(isFor) {
      switch (isFor) {
        case "brandingId":
        case "name":
          navigator.clipboard.writeText(this.supplierGroup[isFor]);
          this.copy[isFor] = true;
          break;
        case "portalLink":
        case "idpUrl":
        case "termsOfServiceEmail":
          navigator.clipboard.writeText(
            this.supplierGroup.channelsConfig.docImage.configPortal[isFor],
          );
          this.copy[isFor] = true;
          break;
      }
      setTimeout(() => {
        this.copy[isFor] = false;
      }, 750);
    },
  },
};
</script>
